import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";

import ComplexRailcar from "./ComplexRailcar";


const styles = {
  trainCard: {
    width: "110px",
    height: "114px",

    border: "1px solid #eee",

    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",

    fontSize: "14px",
    boxSizing: "border-box",
    cursor: "pointer",

  },
  cardNormal: {
    border: "2px solid #86A37B",
  },
  cardWarning: {
    border: "2px solid red"

  },
  
  selectedRailcar : {
    // backgroundColor: "#F8F8F8"
    backgroundColor: "orange"
  },

  warningSign: {
    borderRadius: "50%", 
    color: "white", 
    backgroundColor: "red", 
    fontSize: "12px", 
    width: "16px", 
    height: "16px", 
    textAlign: "center", 
    fontWeight: "500", 
    alignSelf: "flex-start",
    margin: "2px 0px 0px 2px"
  },

  trainNumber: {
    fontWeight: "500",
  },
  trainSvgIcon: {
    width: "100%",
    maxHeight: "80px"
  },
  trainCode: {
    fontSize: "13px"
  }
  
};



const TrainCard = (props) => {
  const { classes, data, setSelectedRailcarId, selectedRailcarId, reverseRailcars} = props;  

  // React.useEffect(() => {
  // }, [data])

  return (
    <div className={`${classes.trainCard} ${!data.railcarName ? classes.cardWarning: classes.cardNormal} ${selectedRailcarId === data.railcarId ? classes.selectedRailcar : "" }`} onClick={() => {setSelectedRailcarId(data.railcarId)}}>
        {!data.railcarName ? <div className={classes.warningSign}>?</div> : <div style={{width: "16px", height: "16px"}}></div>}
        <div className={classes.trainSvgIcon}>
           <ComplexRailcar data={data} reverseRailcars={reverseRailcars} />
        </div>
        <div className={classes.trainNumber}>{data.sequenceNo}</div>
        <div className={`${classes.trainCode}`}>{data.railcarProfileId.substring(0, 4).localeCompare("0000") !== 0 ? data.railcarName : <span style={{color:"#EB3C39", fontWeight: 500}}>?</span>}</div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(TrainCard))

);